module.exports = __webpack_public_path__ + "media/app/img/godot-logo128-eef203d33a23b3bf93f9c915b35fd8aa.png";